module.exports = __webpack_public_path__ + "img/vignette-maxitampons.bc04bf40.jpg";